module.exports = __webpack_public_path__ + "img/order.1743c32f.jpg";